import { render } from "./DashActionQueue.vue?vue&type=template&id=1d06c685&scoped=true&ts=true"
import script from "./DashActionQueue.vue?vue&type=script&lang=ts"
export * from "./DashActionQueue.vue?vue&type=script&lang=ts"

import "./DashActionQueue.vue?vue&type=style&index=0&id=1d06c685&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d06c685"]])

export default __exports__